import dayjs from "dayjs";

const normalizeCase = (strDate) =>
  strDate
    .trim()
    .split(/[\s,-]+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");

export const colFilterDatePattern = (dateParam, filterValue) => {
  if (!dateParam || !filterValue) return false;

  const rowDate = dayjs(dateParam);
  const input = normalizeCase(filterValue.trim());
  if (dayjs(input, "YYYY-MM-DD", true).isValid()) {
    return rowDate.format("YYYY-MM-DD") === input;
  }
  if (
    dayjs(input, "YYYY-M", true).isValid() ||
    dayjs(input, "YYYY-MM", true).isValid() ||
    dayjs(input, "YYYY/M", true).isValid() ||
    dayjs(input, "YYYY/MM", true).isValid()
  ) {
    const parsed = dayjs(
      input,
      ["YYYY-M", "YYYY-MM", "YYYY/M", "YYYY/MM"],
      true
    );
    return (
      rowDate.year() === parsed.year() && rowDate.month() === parsed.month()
    );
  }
  const monthYearParsed = dayjs(input, ["MMM YYYY", "MMMM YYYY"], true);
  if (monthYearParsed.isValid()) {
    return (
      rowDate.month() === monthYearParsed.month() &&
      rowDate.year() === monthYearParsed.year()
    );
  }
  const yearMonthParsed = dayjs(input, ["YYYY MMM", "YYYY MMMM"], true);
  if (yearMonthParsed.isValid()) {
    return (
      rowDate.month() === yearMonthParsed.month() &&
      rowDate.year() === yearMonthParsed.year()
    );
  }
  if (/^\d{4}$/.test(input)) {
    return rowDate.year() === parseInt(input, 10);
  }
  const parsed = dayjs(input);
  if (parsed.isValid()) {
    if (/\d{4}/.test(input)) {
      return rowDate.isSame(parsed, "day");
    }
    return (
      rowDate.date() === parsed.date() && rowDate.month() === parsed.month()
    );
  }
  if (/^\d{1,2}$/.test(input)) {
    const num = parseInt(input, 10);

    return (
      rowDate.date() === num ||
      rowDate.month() + 1 === num ||
      rowDate.year().toString().includes(input)
    );
  }
  const lower = input.toLowerCase();
  const monthName = rowDate.format("MMMM").toLowerCase();
  const monthShort = rowDate.format("MMM").toLowerCase();
  if (monthName.startsWith(lower) || monthShort.startsWith(lower)) {
    return true;
  }
  return false;
};
